"use client";

import { Trans } from "@lingui/react/macro";
import { Badge } from "@/components/ui/badge";
import { getModelQuotaTokenWeight } from "@/lib/ai/model-quota-weight";
import type { ModelId } from "@/lib/ai/models";
import { cn } from "@/lib/utils";

type Props = {
  modelId: ModelId;
  className?: string;
};

export function ModelSelectQuotaWeightBadge({ modelId, className }: Props) {
  const weight = getModelQuotaTokenWeight(modelId);
  if (weight === 1) return null;

  return (
    <Badge
      variant="outline"
      className={cn(
        "h-5 shrink-0 border-muted-foreground/30 px-1.5 text-[10px] font-medium text-muted-foreground",
        className,
      )}
    >
      <Trans>Quota usage ×{weight}</Trans>
    </Badge>
  );
}
